import { lazy, useContext } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { VM } from '../VM';

import { Index as ToolCategories } from '../../__business/components/toolcategories/Index';
import { RenderAPI } from '../../__business/components/global/RenderAPI';
import { Switching } from '../../__business/components/swtiching/Index'
import { Settings } from '../../__business/components/settings/Index';
import { ToolContext } from '../context/ToolContext';
import TakeTrainings from '../../__business/components/regularUser/exam/trainings/Index';
import TakeCourses from '../../__business/components/regularUser/exam/courses/Index';
import { Index as Perzonalization} from '../../core/global/templates/biz/personalization/Index';

let view = VM();
const Navigation = lazy(() => import(`../../__business/components/layouts/navigations${view}/Index`))
const Profile = lazy(() => import(`../../__business/components/profile${view}/Index`))
const HomeAdmin = lazy(() => import (`../../__business/components/home${view}/Index`))
const Speaker = lazy(() => import (`../../__business/components/facilitator/speaker${view}/Index`))
const Provider = lazy(() => import (`../../__business/components/facilitator/provider${view}/Index`))
const Programs = lazy(() => import (`../../__business/components/programs${view}/Index`))
const Reports = lazy(() => import (`../../__business/components/reports${view}/Index`))
//regular users imports
const Certificates = lazy(() => import(`../../__business/components/regularUser/certificates${view}/Index`))
const HomeRegularUser  = lazy(() => import (`../../__business/components/regularUser/dashboard${view}/Index`))
const Trainings = lazy(() => import(`../../__business/components/regularUser/trainings${view}/Index`))
const Profession = lazy(() => import(`../../__business/components/profession${view}/Index`))

export const WebRoute = () => {
    const {tool_state} = useContext(ToolContext)
    let userRole = tool_state.__SESSION.data.uaccess[0].role_name
    // console.log(userRole)
    const location = useLocation().pathname;
    const Home = userRole === 'Super Admin' ? HomeAdmin : userRole === 'Admin' ? HomeAdmin : HomeRegularUser

    return (
        <Switch>
            {/* PROFILE */}
            <Route exact path="/biz/profile" render={props=>(Render(Profile, props, location))} />
            {/* HOME */}
            <Route exact path="/biz" render={props=>(Render(Home, props, location))}/>
            <Route exact path="/biz/switching" render={props=><Switching/>} />
            <Route exact path="/biz/more" render={props=>(Render(Settings, props, location))} />
            <Route exact path="/biz/tool-categories/:params" render={props=>(Render(ToolCategories, props, location))} />

            {/* Trainings */}
            <Route exact path="/biz/programs/:tab/:subtab?" render={props=>(Render(Programs, props, location))}/>

            {/* Facilitator */}
            <Route exact path="/biz/speaker" render={props=>(Render(Speaker, props, location))}/>
            <Route exact path="/biz/provider" render={props=>(Render(Provider, props, location))}/>

            {/* Reports */}
            <Route exact path="/biz/reports/:tab" render={props=>(Render(Reports, props, location))}/>

            {/* RegularUser============================================================ */}

            {/* Profession ROUTES */}
            <Route exact path="/biz/professional" render={props=>(Render(Profession, props, location))} />

            {/* CERTIFICATES ROUTES */}
            <Route exact path="/biz/certificates/:tab" render={props=>(Render(Certificates, props, location))} />
            {/* <Route exact path="/certificates/recently/removed" render={props=>(Render(RecentlyRemoved, props, location, mnt))} /> */}
            {/* <Route exact path="/certificates/list/search" render={props=>(Render(CertificateSearch, props, location, mnt))} /> */}
            {/* TRAINING ROUTES */}
            <Route exact path="/biz/trainings/:tab" render={props=>(Render(Trainings, props, location))} />
            {/* <Route exact path="/trainings/list/search" render={props=>(Render(TrainingSearch, props, location, mnt))} />
            <Route exact path="/trainings/list/exclusive" render={props=>(Render(Exclusive, props, location, mnt))} /> */}
            {/* TRAINING EXAM ROUTES */}
            <Route exact path="/biz/take-training/:tab" render={props=>(Render(TakeTrainings, props, location))} />
            <Route exact path="/biz/take-course/:tab" render={props=>(Render(TakeCourses, props, location))} />
            

            {/* 404 NOT FOUND */}
            <Route>
                <Container>
                    <Box display="flex">
                        Error 404
                    </Box>
                </Container>
            </Route>
        </Switch>
    )
}

const Render = (Component, props, location, userRole, allowedRoles = []) => {
    if (allowedRoles.length && !allowedRoles.includes(userRole)) {
        console.log('not allowed')
        return  (
            <Container>
                <Box display="flex">
                    {`Unauthorized, Login on your proper account if you are NOT accessing as ${userRole}`}
                </Box>
            </Container>
        )
    }
    
    return (
        <>
            {view === '' ? (
                <Box width="100%" height="100%">
                    <Box width="100%" height="100%" display="flex">
                        <Box height="100%">
                            {( location !== '/biz/take-training/pretest' && location !== '/biz/take-training/quiz' && location !== '/biz/take-training/video-lesson' && location !== '/biz/take-training/post-evaluation') && ( location !== '/biz/take-course/pretest' && location !== '/biz/take-course/quiz' && location !== '/biz/take-course/video-lesson' && location !== '/biz/take-course/post-evaluation') && (<Navigation side={1} />)}
                        </Box>
                        <Box display="flex" flexDirection="column" width="100%" height="100%">
                            <Navigation side={0} />
                            <Box height="100%" className="overflowY noScrollcss">
                                <Component {...props} />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            ) : (
                <Box width="100%" height="100%">
                    <Box width="100%" height="100%" display="flex" flexDirection="column">
                        {(location !== '/biz/profiling' && location !== '/biz/more') && (
                            <Box minHeight={location === '/biz' ? '92px' : '40px'}>
                                <Navigation side={0} />
                            </Box>
                        )}
                        <Box height="100%" width="100%" className="overflowY noScrollcss"><Component {...props} /></Box>
                        {(location !== '/profile' && location !== '/biz/profiling') &&
                            <Box minHeight="54px">
                                <Navigation side={2} />
                            </Box>
                        } 
                    </Box>
                </Box>
            )}
            <RenderAPI/>
            <Perzonalization />
        </>
    )
}